import axios from "axios"

const Api = axios.create({baseURL:"https://painel.cleanyoga.club/apiv3",headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})

export default Api;